import { CommentModel } from './Comment.model';
import { MultiLangModel } from './Language.model';

export class NewsModel {
  constructor(data = {}) {
    Object.assign(this, data);
  }
  id!: string;
  businessUnitId: any;
  categoriesIds: string[] = [];
  creationDate?: Date;
  employeeGroupsIds: string[] = [];
  enabled?: boolean;
  endPostDate?: Date;
  highlight?: boolean;
  image: MultiLangModel = new MultiLangModel();
  link: MultiLangModel = new MultiLangModel();
  video: MultiLangModel = new MultiLangModel();
  embed: MultiLangModel = new MultiLangModel();
  typeMedia?: number;
  isEmbed?: boolean;
  restrict?: boolean;
  startPostDate?: Date;
  text!: MultiLangModel;
  title?: MultiLangModel;
  internVideo: string = '';
  redirectLink?: string = '';

  // NewsId?: string;
  // Title?: MultiLangModel;
  // Description?: MultiLangModel;
  // Lead?: MultiLangModel;
  // FatherCategory?: string; // Deveria ser CategoryModel
  // ImagePath?: string;
  // Videolink?: string;
  // MediaType?: number;
  // CreatedAt?: Date;
  Likes: number = 0;
  // Comments?: CommentModel[];
}

export class HomeNewsModel {
  constructor(data = {}) {
    Object.assign(this, data);
  }

  Highlights?: NewsModel[];
  Recruiting?: NewsModel[];
  Administrative?: NewsModel[];
  Performance?: NewsModel[];
  Informative?: NewsModel[];
}

export class NewsFilterModel {
  Search?: string;
  PageIndex: number = 0;
  PageSize: number = 0;
  Highlights?: boolean;
  CategoryId?: string;
  EditorialId?: string;
  language?: string;
  Event? = false;
}

export class LikeModel {
  constructor(data = {}) {
    Object.assign(this, data);
  }

  newsId?: string;
  employeeId?: string;
  totalLikes!: number;
}
